// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ShowFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from show-filled.svg
 */
export default function ShowFilledIcon(props: ShowFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ShowFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M16 8c0-3.4-3.64-6-8-6S0 4.6 0 8s3.64 6 8 6 8-2.6 8-6M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
        />
      </g>
    </svg>
  );
}
